import { TemplateRef, ViewChild } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { SimpleGridService } from './simple-grid.service';

@Component({
  selector: 'crem-simple-grid',
  templateUrl: './simple-grid.component.html',
  styleUrls: ['./simple-grid.component.scss'],
  providers: [SimpleGridService]
})
export class SimpleGridComponent{
  @Input() dataSource: DataSource;
  @Input() id: string;
  @Input() masterDetail? : boolean;
  @Input() allowColumnReordering? = true;
  @Input() detail?: TemplateRef<any>;
  @Input() remoteOperations?: boolean = true;
  @Input() columnAutoWidth?: boolean = true;

  constructor(public gridService: SimpleGridService ) {
   this.dataSource = gridService.getDataSource();

   }


}
